import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import SkuflixVolumeUpIcon from "core/icons/skuflix/SkuflixVolumeUpIcon";
import SkuflixVolumeOffIcon from "core/icons/skuflix/SkuflixVolumeOffIcon";

const PREFIX = "VolumeIndicator";

const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  text: `${PREFIX}-text`,
};

const Root = styled("div")(({ theme, visible }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 10,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1),
  backgroundColor: "rgba(0, 0, 0, 0.75)",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2, 3),
  color: "#fff",
  fontSize: "1.5rem",
  fontWeight: 500,
  fontFamily: theme.typography.fontFamily,
  pointerEvents: "none",
  userSelect: "none",
  opacity: visible ? 1 : 0,
  transition: "opacity 0.2s ease-in-out",
  [`& .${classes.icon}`]: {
    fontSize: "3rem",
  },
  [`& .${classes.text}`]: {
    fontSize: "1rem",
  },
}));

function VolumeIndicator({ volume, muted, show }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Показываем индикатор только когда show === true
    if (show) {
      setVisible(true);
      const timeout = setTimeout(() => {
        setVisible(false);
      }, 800);
      return () => clearTimeout(timeout);
    }
  }, [show]);

  // Важно: рендерим индикатор пока visible=true, даже если show стал false
  // Это позволяет показывать актуальное значение громкости при быстрых изменениях
  if (!visible) {
    return null;
  }

  const displayVolume = muted ? 0 : Math.round(volume * 100);
  const Icon =
    muted || displayVolume === 0 ? SkuflixVolumeOffIcon : SkuflixVolumeUpIcon;

  return (
    <Root visible={visible} className={classes.root}>
      <Icon className={classes.icon} />
      <span className={classes.text}>{displayVolume}%</span>
    </Root>
  );
}

VolumeIndicator.propTypes = {
  volume: PropTypes.number,
  muted: PropTypes.bool,
  show: PropTypes.bool,
};

VolumeIndicator.defaultProps = {
  volume: 1,
  muted: false,
  show: false,
};

export default VolumeIndicator;
